export default __webpack_public_path__ + "static/media/ic_website_builder.efb8b8a5.svg";